var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2626 10.159V5.70269C12.2626 5.29171 11.9308 4.95996 11.5198 4.95996H4.58275C4.17178 4.95996 3.84003 5.29171 3.84003 5.70269V10.159C3.84003 10.57 4.17178 10.9018 4.58275 10.9018H11.5198C11.9308 10.9018 12.2626 10.57 12.2626 10.159ZM11.6139 5.64822C11.7773 5.81162 11.6882 5.97997 11.599 6.06415L9.58873 7.90611L11.5198 9.91643C11.5792 9.98575 11.6189 10.0947 11.5495 10.169C11.4852 10.2482 11.3366 10.2432 11.2722 10.1937L9.10844 8.3468L8.04881 9.31234L6.99414 8.3468L4.83033 10.1937C4.76596 10.2432 4.61741 10.2482 4.55304 10.169C4.48372 10.0947 4.52334 9.98575 4.58275 9.91643L6.51384 7.90611L4.50353 6.06415C4.4144 5.97997 4.32528 5.81162 4.48868 5.64822C4.65207 5.48482 4.82043 5.56405 4.95907 5.68288L8.04881 8.17844L11.1435 5.68288C11.2822 5.56405 11.4505 5.48482 11.6139 5.64822Z",
    fill: "#844DCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.1d9745feecf1cfaf172e74c8f347a7db.svg";
export { ForwardRef as ReactComponent };